// Barra de navegación inferior estilo Android para dispositivos móviles
import { Link, useLocation } from 'react-router-dom'
import { LayoutDashboard, Trophy, Coins, Tv, Wallet } from 'lucide-react'
import useAuthStore from '../../store/useAuthStore'
import useBetStore from '../../store/useBetStore'

export default function BottomNavigation() {
  const location = useLocation()
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const { rechargeModalOpen, setRechargeModalOpen } = useBetStore()

  // Solo mostrar si el usuario está autenticado
  if (!isAuthenticated) return null

  const navItems = [
    { path: '/dashboard', label: 'Panel', icon: LayoutDashboard },
    { path: '/ver-partido', label: 'Ver Partido', icon: Tv },
    { path: '/apuestas', label: 'Apuestas', icon: Coins },
    { path: '/predicciones', label: 'Predicciones', icon: Trophy },
  ]

  return (
    <div className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0A111F] border-t border-border-subtle/40 shadow-[0_-4px_20px_rgba(0,0,0,0.4)] backdrop-blur-md font-body">
      <div className="grid grid-cols-5 h-16 max-w-lg mx-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path
          const Icon = item.icon

          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center transition-all duration-200"
            >
              <div className="flex flex-col items-center justify-center gap-1">
                <Icon
                  className={`w-[22px] h-[22px] transition-all duration-200 ${
                    isActive 
                      ? 'text-cyan scale-110 drop-shadow-[0_0_8px_rgba(0,194,255,0.4)]' 
                      : 'text-text-muted hover:text-text-primary'
                  }`}
                />
                <span
                  className={`text-[9px] font-display font-bold uppercase tracking-wider transition-colors duration-200 ${
                    isActive ? 'text-cyan font-extrabold' : 'text-text-muted'
                  }`}
                >
                  {item.label}
                </span>
              </div>
            </Link>
          )
        })}

        {/* Botón de Mi Billetera */}
        <button
          onClick={() => setRechargeModalOpen(true)}
          className="flex flex-col items-center justify-center transition-all duration-200"
        >
          <div className="flex flex-col items-center justify-center gap-1">
            <Wallet
              className={`w-[22px] h-[22px] transition-all duration-200 ${
                rechargeModalOpen
                  ? 'text-cyan scale-110 drop-shadow-[0_0_8px_rgba(0,194,255,0.4)]'
                  : 'text-text-muted hover:text-text-primary'
              }`}
            />
            <span
              className={`text-[9px] font-display font-bold uppercase tracking-wider transition-colors duration-200 ${
                rechargeModalOpen ? 'text-cyan font-extrabold' : 'text-text-muted'
              }`}
            >
              Billetera
            </span>
          </div>
        </button>
      </div>
    </div>
  )
}
